export enum SocketMessageTypes {
    titleListUpdate = 'titleListUpdate',
    chatCreated = 'chatCreated',
    chatDeleted = 'chatDeleted',
    titleUpdate = 'titleUpdate',
    tokenCountUpdate = 'tokenCountUpdate',
    costUpdate = 'costUpdate',
    contentStream = 'contentStream',
    loadingAnimation = 'loadingAnimation',
    openaiIncidentsUpdated = 'openaiIncidentsUpdated',
    chatUpdated = 'chatUpdated',
}

export enum ContentStreamState {
    complete = 'complete',
    replace = 'replace',
    started = 'started',
    finished = 'finished',
    stoped = 'stoped',
}

export interface TitleListUpdateMessage {
    type?: SocketMessageTypes.titleListUpdate;
    chatIdentifier: string;
    title: string;
}

export interface ChatDeleteMessage {
    type?: SocketMessageTypes.chatDeleted;
    chatIdentifier: string;
}

export interface TitleUpdateMessage {
    type?: SocketMessageTypes.titleUpdate;
    chatIdentifier: string;
    title: string;
}

export interface TokenCountUpdateMessage {
    type?: SocketMessageTypes.tokenCountUpdate;
    chatIdentifier: string;
    count: number;
}

export interface CostUpdateMessage {
    type?: SocketMessageTypes.costUpdate;
    chatIdentifier: string;
    value: number;
}

export interface ContentStreamMessage {
    chatIdentifier: string;
    messageIdentifier: string;
    role: string;
    content: string;
    originalContent: string;
    images: {
        url: string;
        sha1: string;
    }[];
    files: {
        name: string;
        sha1: string;
    }[];
    contentChanged: boolean;
    sources: {
        title: string;
        description: string;
        url: string;
    }[];
    state: string;
    title: string;
    count: number;
    value: number;
    icon: any;
    image?: string;
}

export interface LoadingAnimationMessage {
    type?: SocketMessageTypes.loadingAnimation;
    state: string;
    content: string;
    percentage: number;
    icon: string;
}
